import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './SteelCatalogue.css';

const SteelCatalogue = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedProduct, setExpandedProduct] = useState(null);

  const steelProducts = [
    // TMT BARS
    {
      id: 1,
      category: "tmt",
      mainCategory: "TMT Steel Bars - Fe-500",
      type: "TMT Bar 8mm (Fe-500)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "8mm",
      length: "12m",
      grade: "Fe-500",
      standard: "IS 1786",
      weight: "0.395 kg/m",
      application: "Residential construction, slabs, beams",
      features: ["Earthquake resistant", "High ductility", "Excellent bendability", "Corrosion resistant"],
      stock: "Available"
    },
    {
      id: 2,
      category: "tmt",
      mainCategory: "TMT Steel Bars - Fe-500",
      type: "TMT Bar 10mm (Fe-500)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "10mm",
      length: "12m",
      grade: "Fe-500",
      standard: "IS 1786",
      weight: "0.617 kg/m",
      application: "Columns, beams, footings",
      features: ["Earthquake resistant", "High strength", "Perfect bonding with concrete"],
      stock: "Available"
    },
    {
      id: 3,
      category: "tmt",
      mainCategory: "TMT Steel Bars - Fe-500",
      type: "TMT Bar 12mm (Fe-500)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "12mm",
      length: "12m",
      grade: "Fe-500",
      standard: "IS 1786",
      weight: "0.888 kg/m",
      application: "Main reinforcement, columns, beams",
      features: ["Thermo-mechanically treated", "High yield strength", "Excellent ductility"],
      stock: "Available"
    },
    {
      id: 4,
      category: "tmt",
      mainCategory: "TMT Steel Bars - Fe-500",
      type: "TMT Bar 16mm (Fe-500)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "16mm",
      length: "12m",
      grade: "Fe-500",
      standard: "IS 1786",
      weight: "1.58 kg/m",
      application: "Heavy columns, beams, foundations",
      features: ["Superior strength", "Weldable", "Earthquake resistant"],
      stock: "Available"
    },
    {
      id: 5,
      category: "tmt",
      mainCategory: "TMT Steel Bars - Fe-500",
      type: "TMT Bar 20mm (Fe-500)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "20mm",
      length: "12m",
      grade: "Fe-500",
      standard: "IS 1786",
      weight: "2.47 kg/m",
      application: "Heavy structures, industrial buildings",
      features: ["High load bearing", "Excellent rib pattern", "Anti-corrosive"],
      stock: "Available"
    },
    {
      id: 6,
      category: "tmt",
      mainCategory: "TMT Steel Bars - Fe-500",
      type: "TMT Bar 25mm (Fe-500)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "25mm",
      length: "12m",
      grade: "Fe-500",
      standard: "IS 1786",
      weight: "3.85 kg/m",
      application: "Bridges, heavy foundations, dams",
      features: ["Extra heavy duty", "Maximum strength", "Industrial grade"],
      stock: "Available"
    },
    {
      id: 7,
      category: "tmt",
      mainCategory: "TMT Steel Bars - Fe-500",
      type: "TMT Bar 32mm (Fe-500)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "32mm",
      length: "12m",
      grade: "Fe-500",
      standard: "IS 1786",
      weight: "6.31 kg/m",
      application: "Infrastructure projects, high-rise buildings",
      features: ["Jumbo size", "Ultra-high strength", "Special application"],
      stock: "Available"
    },

    // Fe-550 GRADE TMT BARS
    {
      id: 8,
      category: "tmt-550",
      mainCategory: "TMT Steel Bars - Fe-550 (High Strength)",
      type: "TMT Bar 8mm (Fe-550)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "8mm",
      length: "12m",
      grade: "Fe-550",
      standard: "IS 1786",
      weight: "0.395 kg/m",
      application: "High-rise buildings, seismic zones",
      features: ["Extra high strength", "Superior ductility", "Earthquake resistant"],
      stock: "Available"
    },
    {
      id: 9,
      category: "tmt-550",
      mainCategory: "TMT Steel Bars - Fe-550 (High Strength)",
      type: "TMT Bar 10mm (Fe-550)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "10mm",
      length: "12m",
      grade: "Fe-550",
      standard: "IS 1786",
      weight: "0.617 kg/m",
      application: "High-rise structures, critical zones",
      features: ["550 MPa yield strength", "Excellent bendability", "Weldable"],
      stock: "Available"
    },
    {
      id: 10,
      category: "tmt-550",
      mainCategory: "TMT Steel Bars - Fe-550 (High Strength)",
      type: "TMT Bar 12mm (Fe-550)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "12mm",
      length: "12m",
      grade: "Fe-550",
      standard: "IS 1786",
      weight: "0.888 kg/m",
      application: "Commercial buildings, industrial structures",
      features: ["Premium grade", "High strength-to-weight ratio", "Cost-effective"],
      stock: "Available"
    },
    {
      id: 10,
      category: "tmt-550",
      mainCategory: "TMT Steel Bars - Fe-550 (High Strength)",
      type: "TMT Bar 16mm (Fe-550)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "16mm",
      length: "12m",
      grade: "Fe-550",
      standard: "IS 1786",
      weight: "1.58 kg/m",
      application: "Heavy commercial structures",
      features: ["Maximum strength", "Superior bonding", "Anti-seismic"],
      stock: "Available"
    },
    {
      id: 11,
      category: "tmt-550",
      mainCategory: "TMT Steel Bars - Fe-550 (High Strength)",
      type: "TMT Bar 20mm (Fe-550)",
      icon: "🏗️",
      image: "/images/products/tmt-bars.jpeg",
      diameter: "20mm",
      length: "12m",
      grade: "Fe-550",
      standard: "IS 1786",
      weight: "2.47 kg/m",
      application: "Bridges, flyovers, heavy infrastructure",
      features: ["Ultra-high strength", "Fatigue resistant", "Long life"],
      stock: "Available"
    },

    // STEEL BILLETS
    {
      id: 12,
      category: "billets",
      mainCategory: "Steel Billets",
      type: "Steel Billet 100mm x 100mm",
      icon: "🧱",
      image: "/images/products/steel-billets.jpg",
      size: "100mm x 100mm",
      length: "6m / 9m / 12m",
      grade: "3SP/5SP",
      standard: "ASTM A36 / IS 2830",
      application: "Re-rolling into TMT bars, forging",
      features: ["Premium quality steel", "Uniform composition", "Excellent re-rolling properties"],
      stock: "Available"
    },
    {
      id: 13,
      category: "billets",
      mainCategory: "Steel Billets",
      type: "Steel Billet 125mm x 125mm",
      icon: "🧱",
      image: "/images/products/steel-billets.jpg",
      size: "125mm x 125mm",
      length: "6m / 9m / 12m",
      grade: "3SP/5SP",
      standard: "ASTM A36 / IS 2830",
      application: "Heavy section rolling, structural sections",
      features: ["High purity", "Consistent quality", "Perfect for re-rolling"],
      stock: "Available"
    },
    {
      id: 14,
      category: "billets",
      mainCategory: "Steel Billets",
      type: "Steel Billet 130mm x 130mm",
      icon: "🧱",
      image: "/images/products/steel-billets.jpg",
      size: "130mm x 130mm",
      length: "6m / 9m / 12m",
      grade: "3SP/5SP",
      standard: "ASTM A36 / IS 2830",
      application: "Large section rolling, heavy TMT bars",
      features: ["Premium billet", "Controlled chemistry", "Defect-free"],
      stock: "Available"
    },

    // DEFORMED BARS
    {
      id: 15,
      category: "deformed",
      mainCategory: "Deformed Steel Bars",
      type: "Deformed Bar 10mm",
      icon: "🔨",
      image: "/images/products/deformed-bars.jpg",
      diameter: "10mm",
      length: "12m",
      grade: "Fe-415",
      standard: "IS 1786",
      application: "General construction, reinforcement",
      features: ["Ribbed pattern", "Excellent bonding", "Standard grade"],
      stock: "Available"
    },
    {
      id: 16,
      category: "deformed",
      mainCategory: "Deformed Steel Bars",
      type: "Deformed Bar 12mm",
      icon: "🔨",
      image: "/images/products/deformed-bars.jpg",
      diameter: "12mm",
      length: "12m",
      grade: "Fe-415",
      standard: "IS 1786",
      application: "Beams, columns, slabs",
      features: ["High bonding strength", "Consistent quality", "Easy to work"],
      stock: "Available"
    },
    {
      id: 17,
      category: "deformed",
      mainCategory: "Deformed Steel Bars",
      type: "Deformed Bar 16mm",
      icon: "🔨",
      image: "/images/products/deformed-bars.jpg",
      diameter: "16mm",
      length: "12m",
      grade: "Fe-415",
      standard: "IS 1786",
      application: "Heavy reinforcement",
      features: ["Superior grip", "Load-bearing", "Durable"],
      stock: "Available"
    },

    // PLAIN ROUND BARS
    {
      id: 18,
      category: "round",
      mainCategory: "Plain Round Bars",
      type: "Round Bar 6mm",
      icon: "⚪",
      image: "/images/products/plain-bars.jpg",
      diameter: "6mm",
      length: "6m / 12m",
      grade: "Mild Steel",
      application: "Fabrication, general purposes",
      features: ["Smooth surface", "Easy to machine", "Versatile"],
      stock: "Available"
    },
    {
      id: 19,
      category: "round",
      mainCategory: "Plain Round Bars",
      type: "Round Bar 8mm",
      icon: "⚪",
      image: "/images/products/plain-bars.jpg",
      diameter: "8mm",
      length: "6m / 12m",
      grade: "Mild Steel",
      application: "Fabrication, dowels, pins",
      features: ["Uniform diameter", "Good finish", "Weldable"],
      stock: "Available"
    },
    {
      id: 20,
      category: "round",
      mainCategory: "Plain Round Bars",
      type: "Round Bar 10mm",
      icon: "⚪",
      image: "/images/products/plain-bars.jpg",
      diameter: "10mm",
      length: "6m / 12m",
      grade: "Mild Steel / Medium Carbon",
      application: "Shafts, machined parts, general engineering",
      features: ["Precision rolled", "Consistent quality", "Machinable"],
      stock: "Available"
    },
    {
      id: 21,
      category: "round",
      mainCategory: "Plain Round Bars",
      type: "Round Bar 12mm",
      icon: "⚪",
      image: "/images/products/plain-bars.jpg",
      diameter: "12mm",
      length: "6m / 12m",
      grade: "Mild Steel",
      application: "Construction, fabrication",
      features: ["Smooth finish", "Tight tolerances", "Versatile"],
      stock: "Available"
    },
    {
      id: 22,
      category: "round",
      mainCategory: "Plain Round Bars",
      type: "Round Bar 16mm",
      icon: "⚪",
      image: "/images/products/plain-bars.jpg",
      diameter: "16mm",
      length: "6m / 12m",
      grade: "Mild Steel",
      application: "Heavy fabrication, structural supports",
      features: ["Heavy duty", "Strong", "Durable"],
      stock: "Available"
    },
    {
      id: 23,
      category: "round",
      mainCategory: "Plain Round Bars",
      type: "Round Bar 20mm",
      icon: "⚪",
      image: "/images/products/plain-bars.jpg",
      diameter: "20mm",
      length: "6m / 12m",
      grade: "Mild Steel",
      application: "Industrial fabrication",
      features: ["Large diameter", "High strength", "Multi-purpose"],
      stock: "Available"
    },
    {
      id: 24,
      category: "round",
      mainCategory: "Plain Round Bars",
      type: "Round Bar 25mm",
      icon: "⚪",
      image: "/images/products/plain-bars.jpg",
      diameter: "25mm",
      length: "6m / 12m",
      grade: "Mild Steel",
      application: "Heavy engineering",
      features: ["Extra heavy", "Industrial grade", "Premium quality"],
      stock: "Available"
    },

    // SQUARE BARS
    {
      id: 25,
      category: "square",
      mainCategory: "Square Bars",
      type: "Square Bar 10mm",
      icon: "⬛",
      image: "/images/products/square-bars.jpg",
      size: "10mm x 10mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Gates, railings, fabrication",
      features: ["Sharp edges", "Uniform section", "Easy to weld"],
      stock: "Available"
    },
    {
      id: 26,
      category: "square",
      mainCategory: "Square Bars",
      type: "Square Bar 12mm",
      icon: "⬛",
      image: "/images/products/square-bars.jpg",
      size: "12mm x 12mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Structural fabrication",
      features: ["Precision rolled", "Consistent dimensions"],
      stock: "Available"
    },
    {
      id: 27,
      category: "square",
      mainCategory: "Square Bars",
      type: "Square Bar 16mm",
      icon: "⬛",
      image: "/images/products/square-bars.jpg",
      size: "16mm x 16mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Heavy gates, frames",
      features: ["Strong sections", "Clean finish"],
      stock: "Available"
    },
    {
      id: 28,
      category: "square",
      mainCategory: "Square Bars",
      type: "Square Bar 20mm",
      icon: "⬛",
      image: "/images/products/square-bars.jpg",
      size: "20mm x 20mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Industrial structures",
      features: ["Heavy duty", "Precision made"],
      stock: "Available"
    },

    // FLAT BARS
    {
      id: 29,
      category: "flat",
      mainCategory: "Flat Bars",
      type: "Flat Bar 25mm x 3mm",
      icon: "📏",
      image: "/images/products/flat-bars.jpg",
      size: "25mm x 3mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Gates, brackets, general fabrication",
      features: ["Flat surface", "Uniform thickness", "Easy to cut"],
      stock: "Available"
    },
    {
      id: 30,
      category: "flat",
      mainCategory: "Flat Bars",
      type: "Flat Bar 25mm x 5mm",
      icon: "📏",
      image: "/images/products/flat-bars.jpg",
      size: "25mm x 5mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Structural supports",
      features: ["Medium thickness", "Strong", "Versatile"],
      stock: "Available"
    },
    {
      id: 31,
      category: "flat",
      mainCategory: "Flat Bars",
      type: "Flat Bar 25mm x 6mm",
      icon: "📏",
      image: "/images/products/flat-bars.jpg",
      size: "25mm x 6mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Heavy brackets, supports",
      features: ["Thicker section", "Load bearing"],
      stock: "Available"
    },
    {
      id: 32,
      category: "flat",
      mainCategory: "Flat Bars",
      type: "Flat Bar 40mm x 3mm",
      icon: "📏",
      image: "/images/products/flat-bars.jpg",
      size: "40mm x 3mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Wide applications, gates",
      features: ["Wider surface", "Light to medium duty"],
      stock: "Available"
    },
    {
      id: 33,
      category: "flat",
      mainCategory: "Flat Bars",
      type: "Flat Bar 40mm x 5mm",
      icon: "📏",
      image: "/images/products/flat-bars.jpg",
      size: "40mm x 5mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Structural fabrication",
      features: ["Wide and strong", "Industrial use"],
      stock: "Available"
    },
    {
      id: 34,
      category: "flat",
      mainCategory: "Flat Bars",
      type: "Flat Bar 50mm x 5mm",
      icon: "📏",
      image: "/images/products/flat-bars.jpg",
      size: "50mm x 5mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Heavy fabrication",
      features: ["Extra wide", "Heavy duty", "Premium"],
      stock: "Available"
    },
    {
      id: 35,
      category: "flat",
      mainCategory: "Flat Bars",
      type: "Flat Bar 50mm x 6mm",
      icon: "📏",
      image: "/images/products/flat-bars.jpg",
      size: "50mm x 6mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Industrial structures",
      features: ["Maximum strength", "Heavy section"],
      stock: "Available"
    },

    // ANGLE BARS
    {
      id: 36,
      category: "angle",
      mainCategory: "Angle Bars - Equal",
      type: "Angle Bar 25mm x 25mm x 3mm",
      icon: "📐",
      image: "/images/products/angle-bars.jpg",
      size: "25mm x 25mm x 3mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Frames, supports, racks",
      features: ["Equal legs", "Light structural", "Easy to weld"],
      stock: "Available"
    },
    {
      id: 37,
      category: "angle",
      mainCategory: "Angle Bars - Equal",
      type: "Angle Bar 30mm x 30mm x 3mm",
      icon: "📐",
      image: "/images/products/angle-bars.jpg",
      size: "30mm x 30mm x 3mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Light structures, frames",
      features: ["Medium size", "Versatile", "Strong"],
      stock: "Available"
    },
    {
      id: 38,
      category: "angle",
      mainCategory: "Angle Bars - Equal",
      type: "Angle Bar 40mm x 40mm x 3mm",
      icon: "📐",
      image: "/images/products/angle-bars.jpg",
      size: "40mm x 40mm x 3mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Gates, frames, supports",
      features: ["Standard size", "Popular", "Multi-purpose"],
      stock: "Available"
    },
    {
      id: 39,
      category: "angle",
      mainCategory: "Angle Bars - Equal",
      type: "Angle Bar 40mm x 40mm x 5mm",
      icon: "📐",
      image: "/images/products/angle-bars.jpg",
      size: "40mm x 40mm x 5mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Heavy frames, structural",
      features: ["Thicker leg", "Heavier duty", "Strong"],
      stock: "Available"
    },
    {
      id: 40,
      category: "angle",
      mainCategory: "Angle Bars - Equal",
      type: "Angle Bar 50mm x 50mm x 5mm",
      icon: "📐",
      image: "/images/products/angle-bars.jpg",
      size: "50mm x 50mm x 5mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Structural frames, trusses",
      features: ["Large size", "Industrial grade", "High strength"],
      stock: "Available"
    },
    {
      id: 41,
      category: "angle",
      mainCategory: "Angle Bars - Equal",
      type: "Angle Bar 50mm x 50mm x 6mm",
      icon: "📐",
      image: "/images/products/angle-bars.jpg",
      size: "50mm x 50mm x 6mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Heavy structures, columns",
      features: ["Extra thick", "Maximum strength", "Heavy duty"],
      stock: "Available"
    },
    {
      id: 42,
      category: "angle",
      mainCategory: "Angle Bars - Equal",
      type: "Angle Bar 65mm x 65mm x 6mm",
      icon: "📐",
      image: "/images/products/angle-bars.jpg",
      size: "65mm x 65mm x 6mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Industrial buildings, bridges",
      features: ["Jumbo size", "Structural grade", "Premium"],
      stock: "Available"
    },

    // CHANNELS
    {
      id: 43,
      category: "channel",
      mainCategory: "Channel Sections",
      type: "Channel 75mm x 40mm (C75)",
      icon: "⎕",
      image: "/images/products/channels.jpg",
      size: "75mm x 40mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Purlins, frames, supports",
      features: ["C-section", "Light structural", "Easy to install"],
      stock: "Available"
    },
    {
      id: 44,
      category: "channel",
      mainCategory: "Channel Sections",
      type: "Channel 100mm x 50mm (C100)",
      icon: "⎕",
      image: "/images/products/channels.jpg",
      size: "100mm x 50mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Roof structures, industrial sheds",
      features: ["Medium channel", "Versatile", "Strong"],
      stock: "Available"
    },
    {
      id: 45,
      category: "channel",
      mainCategory: "Channel Sections",
      type: "Channel 125mm x 65mm (C125)",
      icon: "⎕",
      image: "/images/products/channels.jpg",
      size: "125mm x 65mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Heavy structures, columns",
      features: ["Large channel", "High load capacity", "Industrial"],
      stock: "Available"
    },
    {
      id: 46,
      category: "channel",
      mainCategory: "Channel Sections",
      type: "Channel 150mm x 75mm (C150)",
      icon: "⎕",
      image: "/images/products/channels.jpg",
      size: "150mm x 75mm",
      length: "6m",
      grade: "Mild Steel",
      application: "Main structural members",
      features: ["Extra large", "Maximum strength", "Premium"],
      stock: "Available"
    },

    // BEAMS
    {
      id: 47,
      category: "beam",
      mainCategory: "I-Beams",
      type: "I-Beam 100mm x 50mm (ISMB 100)",
      icon: "📊",
      image: "/images/products/ibeams.jpg",
      size: "100mm x 50mm",
      length: "6m / 9m / 12m",
      grade: "Mild Steel",
      standard: "IS 808",
      application: "Light structural frames",
      features: ["I-section", "Light beam", "General purpose"],
      stock: "Available"
    },
    {
      id: 48,
      category: "beam",
      mainCategory: "I-Beams",
      type: "I-Beam 150mm x 75mm (ISMB 150)",
      icon: "📊",
      image: "/images/products/ibeams.jpg",
      size: "150mm x 75mm",
      length: "6m / 9m / 12m",
      grade: "Mild Steel",
      standard: "IS 808",
      application: "Medium structures, supports",
      features: ["Medium beam", "Good load capacity", "Versatile"],
      stock: "Available"
    },
    {
      id: 49,
      category: "beam",
      mainCategory: "I-Beams",
      type: "I-Beam 200mm x 100mm (ISMB 200)",
      icon: "📊",
      image: "/images/products/ibeams.jpg",
      size: "200mm x 100mm",
      length: "6m / 9m / 12m",
      grade: "Mild Steel",
      standard: "IS 808",
      application: "Heavy structures, industrial buildings",
      features: ["Large beam", "High strength", "Structural grade"],
      stock: "Available"
    },
    {
      id: 50,
      category: "beam",
      mainCategory: "I-Beams",
      type: "I-Beam 250mm x 125mm (ISMB 250)",
      icon: "📊",
      image: "/images/products/ibeams.jpg",
      size: "250mm x 125mm",
      length: "6m / 9m / 12m",
      grade: "Mild Steel",
      standard: "IS 808",
      application: "Bridges, heavy industrial",
      features: ["Extra large", "Maximum capacity", "Premium"],
      stock: "Available"
    },

    // WIRE RODS
    {
      id: 51,
      category: "wire",
      mainCategory: "Wire Rods",
      type: "Wire Rod 5.5mm",
      icon: "🧵",
      image: "/images/products/wire-rods.jpg",
      diameter: "5.5mm",
      weight: "Coils of 1 ton",
      grade: "Low Carbon / High Carbon",
      application: "Wire drawing, nails, mesh",
      features: ["Hot rolled", "Consistent quality", "Excellent drawability"],
      stock: "Available"
    },
    {
      id: 52,
      category: "wire",
      mainCategory: "Wire Rods",
      type: "Wire Rod 6.5mm",
      icon: "🧵",
      image: "/images/products/wire-rods.jpg",
      diameter: "6.5mm",
      weight: "Coils of 1 ton",
      grade: "Low Carbon",
      application: "General wire products",
      features: ["Popular size", "Clean surface", "Uniform properties"],
      stock: "Available"
    },
    {
      id: 53,
      category: "wire",
      mainCategory: "Wire Rods",
      type: "Wire Rod 8mm",
      icon: "🧵",
      image: "/images/products/wire-rods.jpg",
      diameter: "8mm",
      weight: "Coils of 1 ton",
      grade: "Low Carbon / Medium Carbon",
      application: "Mesh, fencing, construction",
      features: ["Heavy rod", "Strong", "Versatile"],
      stock: "Available"
    }
  ];

  const categories = [
    { id: 'all', label: 'All Products', icon: '🔩' },
    { id: 'tmt', label: 'TMT Fe-500', icon: '🏗️' },
    { id: 'tmt-550', label: 'TMT Fe-550', icon: '🏗️' },
    { id: 'billets', label: 'Billets', icon: '🧱' },
    { id: 'deformed', label: 'Deformed', icon: '🔨' },
    { id: 'round', label: 'Round', icon: '⚪' },
    { id: 'square', label: 'Square', icon: '⬛' },
    { id: 'flat', label: 'Flat', icon: '📏' },
    { id: 'angle', label: 'Angle', icon: '📐' },
    { id: 'channel', label: 'Channel', icon: '⎕' },
    { id: 'beam', label: 'Beams', icon: '📊' },
    { id: 'wire', label: 'Wire Rods', icon: '🧵' }
  ];

  const filteredProducts = steelProducts.filter(product => {
    const matchesSearch = 
      product.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (product.mainCategory && product.mainCategory.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (product.diameter && product.diameter.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (product.size && product.size.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (product.grade && product.grade.toLowerCase().includes(searchTerm.toLowerCase()));
    
    if (activeCategory === 'all') return matchesSearch;
    if (activeCategory === 'tmt') return matchesSearch && product.category === 'tmt';
    if (activeCategory === 'tmt-550') return matchesSearch && product.category === 'tmt-550';
    return matchesSearch && product.category === activeCategory;
  });

  const toggleExpand = (id) => {
    if (expandedProduct === id) {
      setExpandedProduct(null);
    } else {
      setExpandedProduct(id);
    }
  };

  // Get active category label for display
  const getActiveCategoryLabel = () => {
    const category = categories.find(c => c.id === activeCategory);
    return category ? category.label : 'All Products';
  };

  return (
    <div className="catalogue-page steel-catalogue">
      <div className="container">
        <h1 className="catalogue-title">Masai Rolling Mills - Steel Catalogue</h1>
        <p className="catalogue-subtitle">Quality TMT Bars, Billets & Structural Steel</p>

        <div className="catalogue-search">
          <input
            type="text"
            placeholder="Search by size, grade, or product type..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <span className="search-icon">🔍</span>
        </div>

        {/* Persistent Category Tabs */}
        <div className="catalogue-tabs steel-tabs">
          {categories.map(cat => (
            <button
              key={cat.id}
              className={`tab-btn ${activeCategory === cat.id ? 'active' : ''}`}
              onClick={() => {
                setActiveCategory(cat.id);
                setExpandedProduct(null); // Collapse any expanded product when switching categories
              }}
            >
              <span className="tab-icon">{cat.icon}</span>
              <span className="tab-label">{cat.label}</span>
            </button>
          ))}
        </div>

        <div className="results-count">
          Showing {filteredProducts.length} products in <strong>{getActiveCategoryLabel()}</strong>
        </div>

        <div className="catalogue-enhanced-grid steel-grid">
          {filteredProducts.map((product) => (
            <div key={product.id} className={`catalogue-enhanced-card steel-card ${expandedProduct === product.id ? 'expanded' : ''}`}>
              <div className="card-header" style={{ backgroundColor: '#666666' }}>
                {product.image && (
                  <div className="card-header-image">
                    <img src={product.image} alt={product.type} />
                  </div>
                )}
                <span className="card-icon">{product.icon}</span>
                <h3>{product.type}</h3>
                <button className="expand-btn" onClick={() => toggleExpand(product.id)}>
                  {expandedProduct === product.id ? '−' : '+'}
                </button>
              </div>
              
              <div className="card-content">
                <div className="card-main-category">{product.mainCategory}</div>
                
                <div className="card-specs">
                  {product.diameter && (
                    <div className="spec-item">
                      <span className="spec-label">Diameter:</span>
                      <span className="spec-value highlight">{product.diameter}</span>
                    </div>
                  )}
                  
                  {product.size && (
                    <div className="spec-item">
                      <span className="spec-label">Size:</span>
                      <span className="spec-value">{product.size}</span>
                    </div>
                  )}
                  
                  {product.grade && (
                    <div className="spec-item">
                      <span className="spec-label">Grade:</span>
                      <span className="spec-value">{product.grade}</span>
                    </div>
                  )}
                  
                  {product.length && (
                    <div className="spec-item">
                      <span className="spec-label">Length:</span>
                      <span className="spec-value">{product.length}</span>
                    </div>
                  )}
                  
                  {product.weight && (
                    <div className="spec-item">
                      <span className="spec-label">Weight:</span>
                      <span className="spec-value">{product.weight}</span>
                    </div>
                  )}
                  
                  {product.standard && (
                    <div className="spec-item">
                      <span className="spec-label">Standard:</span>
                      <span className="spec-value">{product.standard}</span>
                    </div>
                  )}
                  
                  {product.stock && (
                    <div className="spec-item stock">
                      <span className="spec-label">Stock:</span>
                      <span className="spec-value available">{product.stock}</span>
                    </div>
                  )}
                </div>

                {expandedProduct === product.id && (
                  <div className="product-extended">
                    <h4>Features & Applications</h4>
                    <ul className="feature-list">
                      {product.features && product.features.map((feature, i) => (
                        <li key={i}>✓ {feature}</li>
                      ))}
                      {product.application && (
                        <li className="application-item">
                          <strong>Application:</strong> {product.application}
                        </li>
                      )}
                    </ul>
                    <div className="extended-actions">
                      <Link to={`/contact?product=${encodeURIComponent(product.type)}`} className="btn-quote">Request Quote</Link>
                    </div>
                  </div>
                )}
                
                {expandedProduct !== product.id && (
                  <div className="card-actions">
                    <Link to={`/contact?product=${encodeURIComponent(product.type)}`} className="btn-quote">Get Quote</Link>
                    <button className="btn-view" onClick={() => toggleExpand(product.id)}>Details</button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {filteredProducts.length === 0 && (
          <div className="no-results">
            <p>No products found matching "{searchTerm}"</p>
          </div>
        )}

        <div className="catalogue-footer steel-footer">
          <p>For bulk orders or custom steel requirements, contact us:</p>
          <p className="contact-info">
            <strong>Masai Rolling Mills Ltd</strong><br />
            T: 0738 200500<br />
            Kitengela Township, Off Mombasa Road
          </p>
        </div>
      </div>
    </div>
  );
};

export default SteelCatalogue;